import axios from "axios";
import { banner, webView } from "../../variables/webView";
import GetQrLink from "./getQrLink";
export { GetQrLink };
let token = window.token;

export const QrVCard = async (data) => {
  const formData = new FormData();
  formData.append("name", data[0]);
  formData.append("date_of_birth", data[1]);
  data[2].forEach((item, index) => {
    if (index === 0 && item.length) {
      formData.append(`phones[+${item}]`, 0);
    } else if (item.length) {
      formData.append(`phones[+${item}]`, 1);
    }
  });
  data[3].forEach((item, index) => {
    if (index === 0 && item.length) {
      formData.append(`websites[${item}]`, 0);
    } else if (item.length) {
      formData.append(`websites[${item}]`, 1);
    }
  });
  formData.append("organization", data[4]);
  formData.append("position", data[5]);
  formData.append("address", data[6]);
  formData.append("last_name", data[12]);
  data[7].forEach((item, index) => {
    if (index === 0 && item.length) {
      formData.append(`emails[${item}]`, 0);
    } else if (item.length) {
      formData.append(`emails[${item}]`, 1);
    }
  });
  formData.append("photo", data[13] || "");
  formData.append("qrTitle", data[9]);
  formData.append("color", data[10]);
  formData.append("type", 7);
  formData.append("vcf_type", 0);
  !!token && formData.append("token", token);
  let response = null;
  try {
    response = await axios({
      url: webView ? `/vcard/ajax/new${banner}` : "/vcard/ajax/new",
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};

export const QrVCardEdit = async (data) => {
  let response = null;
  const formData = new FormData();
  formData.append("name", data[1]);
  formData.append("date_of_birth", data[2]);
  data[3].forEach((item, index) => {
    if (index === 0 && item.length) {
      formData.append(`phones[+${item}]`, 0);
    } else if (item.length) {
      formData.append(`phones[+${item}]`, 1);
    }
  });
  data[4].forEach((item, index) => {
    if (index === 0 && item.length) {
      formData.append(`websites[${item}]`, 0);
    } else if (item.length) {
      formData.append(`websites[${item}]`, 1);
    }
  });
  formData.append("organization", data[5]);
  formData.append("position", data[6]);
  formData.append("address", data[7]);
  formData.append("last_name", data[13]);
  data[8].forEach((item, index) => {
    if (index === 0 && item.length) {
      formData.append(`emails[${item}]`, 0);
    } else if (item.length) {
      formData.append(`emails[${item}]`, 1);
    }
  });
  formData.append("photo", data[14] || "");
  formData.append("qrTitle", data[10]);
  formData.append("color", data[11]);
  formData.append("type", 7);
  formData.append("vcf_type", 0);

  try {
    response = await axios({
      url: `/vcard/ajax/edit/${data[0]}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};

export const QrVCardFile = async (data) => {
  const formData = new FormData();
  formData.append("qrTitle", data[0]);
  formData.append("photo", (data[1].length && data[1][0]?.file) || "");
  formData.append("type", 7);
  formData.append("vcf_type", 1);
  !!token && formData.append("token", token);
  let response = null;
  try {
    response = await axios({
      url: webView ? `/vcard/ajax/new${banner}` : "/vcard/ajax/new",
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};

export const QrVCardFileEdit = async (data) => {
  let response = null;
  const formData = new FormData();
  formData.append("qrTitle", data[1]);
  formData.append("photo", (data[2].length && data[2][0]?.file) || "");
  formData.append("type", 7);
  formData.append("vcf_type", 1);

  try {
    response = await axios({
      url: `/vcard/ajax/edit/${data[0]}`,
      method: "POST",
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
};
